import React from 'react';

type Props = {
    footer?: string;
};

export default function TemplateFooter({ footer }: Props) {
    return (
        <div className="template-footer">
            <div className="step-counter flexbox align-center justify-center">3</div>
            <span>{footer ? footer : 'Sample text in the footer'}</span>
        </div>
    );
}
